<template>
  <!-- Kit toast viewport (im- design system §14): fixed top-right under the
       top bar. One viewport for every toast — the legacy per-position
       containers are gone (no caller ever passed a position). -->
  <div v-if="list.length" class="im-toast-viewport">
    <vue-toastr v-for="data in list" :key="data._toastId" :data="data" @setInterval="handleInterval" />
  </div>
</template>

<script setup>
  import VueToastr from './VueToastr.vue'
  import FlashMessageService from '@services/FlashMessages'
  import { onMounted, ref, nextTick } from 'vue'

  let list = ref([])
  let nextId = 0

  onMounted(() => {
    FlashMessageService.registerCallbacks(addToast, removeToast)
  })

  function addToast (data) {
    // Stable key: index keys would re-mount (and restart) the countdown of
    // every toast behind one that closes.
    data._toastId = ++nextId
    list.value.push(data)

    // if have onCreated
    if (data.onCreated) {
      // wait for dom update after call cb
      nextTick().then(() => {
        data.onCreated()
      })
    }
  }

  function removeToast (data) {
    // if have onClosed
    if (data.onClosed) {
      data.onClosed()
    }

    list.value.splice(list.value.indexOf(data), 1)
  }

  function handleInterval (data) {
    removeToast(data)
  }
</script>

<style lang="scss">
  /* Links inside a toast body sit on the dark ink card — the app-wide link
     color has no contrast there. */
  .im-toast-title a,
  .im-toast-desc a {
    color: var(--color-on);
    text-decoration: underline;
  }
</style>
